<template>
    <div>
        <b-card no-body class="bdr-tabs">
            <b-tabs card>
                <b-tab title="Сводная таблица" active>
                    <b-card-text>
                        <div class="bdr-results-head">
                            <div><h5>Бюджет доходов и расходов за {{ selected.year }} год</h5></div>
                            <div class="bdr-results-head-selects" style="align-items: center;">
                                <b-button
                                    @click="updateData()"
                                    size="sm"
                                    variant="outline-secondary"
                                    class="ml-2"
                                    style="width: 37px; height: 35px;"
                                    :disabled="loading"
                                >
                                    <b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" :animation="loading ? 'spin' : ''"></b-icon>
                                </b-button>
                                <div class="ml-2">
                                    <b-form-select 
                                        v-model="selected.unit"
                                        :options="unitOptions"
                                        size="sm"
                                        style="max-width: 150px;"
                                        class="custom-select-height-small"
                                        @change="getBDR"
                                        :disabled="loading"
                                    ></b-form-select>
                                </div>
                                <div class="ml-2">
                                    <b-form-select 
                                        v-model="selected.year"
                                        :options="yearList"
                                        size="sm"
                                        style="max-width: 150px;"
                                        class="custom-select-height-small"
                                        :disabled="loading"
                                        @change="getBDR"
                                    ></b-form-select>
                                </div>
                                <button class="ml-2 bdr-results-button" style="height: 37px;" @click="exportTable('bdr-result-table', 'Таблица bdr')">
                                    <b-icon
                                        icon="cloud-upload"
                                        scale="1.2"
                                        variant="secondary"
                                        :disabled="loading"
                                    ></b-icon>
                                </button>
                            </div>
                        </div>
                        <div class="bdr-result-table mt-5 mb-3" v-if="bdr.length !== 0">
                            <component :is="currentTable" :bdr="bdr" :months="months" :year="selected.year"></component>
                        </div>
                    </b-card-text>
                </b-tab>
                <b-tab title="Загрузка данных">
                    <b-card-text>
                        <div class="bdr-results-head">
                            <div><h5>Загрузка данных за {{ this.months[selected.month - 1] }}, {{ selected.year }} год</h5></div>
                            <div class="bdr-results-head-selects">
                                <button 
                                    v-if="prevFiles.length > 0"
                                    class="btn btn-primary" 
                                    style="height: 37px"
                                    @click="addingFiles = !addingFiles"
                                >
                                    <b-icon icon="file-plus"></b-icon>
                                </button>
                                <button 
                                    v-if="prevFiles.length > 0"
                                    class="btn btn-secondary ml-2" 
                                    style="height: 37px"
                                    @click="clearMonth()"
                                >
                                    <span>Очистить</span>
                                </button>
                                <button 
                                    v-if="prevFiles.length > 0"
                                    class="btn btn-secondary ml-2" 
                                    style="height: 37px"
                                    @click="recalculateFiles(1)"
                                >
                                    <span v-if="!recalculatingFiles">Пересчитать</span>
                                    <span v-if="recalculatingFiles">Считаю <i class="fas fa-spinner fa-spin ml-1"></i></span>
                                </button>
                                <!--                                 
                                <div class="ml-2">
                                    <b-form-select 
                                        v-model="selected.unit" 
                                        :options="unitOptions"
                                        size="sm"
                                        class="custom-select-height-small"
                                        style="max-width: 150px;"
                                    ></b-form-select> 
                                </div>            -->
                                <div class="ml-2">
                                    <b-form-select 
                                        v-model="selected.month" 
                                        :options="monthList"
                                        size="sm"
                                        class="custom-select-height-small"
                                        style="max-width: 150px;"
                                        @change="saveSelectedData"
                                    ></b-form-select>
                                </div>
                                <div class="ml-2">
                                    <b-form-select 
                                        v-model="selected.year"
                                        :options="yearList"
                                        size="sm"
                                        class="custom-select-height-small"
                                        style="max-width: 150px;"
                                        @change="saveSelectedData"
                                    ></b-form-select>
                                </div>
                            </div>
                        </div>
                        <div class="bdr-upload-documents mt-5 mb-3">                        
                            <div class="row pl-3 pr-3 mt-3">
                                <b-overlay
                                    id="overlay-background-files"
                                    :show="recalculatingFiles || loading"
                                    style="width: 100%;"
                                >                            
                                <div class="col-md-12" v-for="(item, index) in prevFiles" :key="index">
                                    <div class="row list-block shadow align-items-center mb-3 list-block__download">
            
                                        <div class="list-block_doc">
                                            <a class="cursor-pointer d-block position-relative" @click.prevent="openFile(item)">
                                                <img :id="'doc-logo-'+index" :src="'/img/icon-document.svg'" style="width: 34px;">
                                                <div class="list-block_doc_extention">{{ fileExtension(item.path) }}</div>
                                            </a>
            
                                        </div>
                                        <div class="list-block_text ml-3">
                                            <ul class="mb-0">
                                                <li><span class="font-weight-bold text-uppercase text-brown ml-2">{{item.name}}</span></li>
                                            </ul>
                                        </div>
                                        <div class="d-flex align-items-center ml-auto">
                                            <div class="list-block_action ml-3" v-if="recalcOtchet.otchet && recalcOtchet.otchet[item.name]">
                                                <b-button v-b-toggle="item.name" class="m-1">История (<span title="Спорных строк">{{ numberOfFights(item.name) }}</span> / <span title="Ошибочных строк">{{ numberOfFaults(item.name) }}</span>)</b-button>
                                            </div>
                                            <div class="list-block_action ml-3">
                                                <a :href="hfs + item.path" download class="list-block_icon cursor-pointer p-1">
                                                    <i class="fas fa-download"></i>
                                                </a>
                                            </div>
                                            <!-- <div class="list-block_action ml-3">
                                                <span class="list-block_icon cursor-pointer p-1" @click="openFile(item)">
                                                    <i class="far fa-eye"></i>
                                                </span>
                                            </div> -->
                                            <div class="list-block_action ml-3">
                                                <span class="list-block_icon cursor-pointer p-1" @click="recalcOneFile(item)" title="Пересчитать только этот файл">
                                                    <i class="fas fa-redo-alt"></i>
                                                </span>
                                            </div>
                                            <div class="list-block_action ml-3">
                                                <span class="list-block_icon cursor-pointer p-1" @click="deleteFile(item)">
                                                    <i class="far fa-trash-alt"></i>
                                                </span>
                                            </div>

                                        </div>
                                    </div>

                                    <div v-if="recalcOtchet.otchet && recalcOtchet.otchet[item.name]">
                                        <b-collapse :id="item.name">
                                            <b-table-simple hover small responsive class="table-otchet-of-import">
                                                <b-tr
                                                    v-for="(row, r_index) in recalcOtchet.otchet[item.name]"
                                                    :key="r_index"
                                                    :variant="variantByResult(row.result)"
                                                >
                                                    <b-td>{{ r_index }}</b-td>
                                                    <template
                                                        v-for="(column, c_index) in row"
                                                    >
                                                        <b-td
                                                            v-if="c_index != 'result' 
                                                                && c_index != 'fault' 
                                                                && c_index != 'fight'
                                                                && c_index != 'is-white-row'"
                                                            :key="c_index"
                                                        >
                                                            {{ column }}
                                                        </b-td>
                                                    </template>
                                                    <b-td class="text-center" style="width: 100px">
                                                        <template v-if="row['result'] == 'done'">
                                                            <b-icon 
                                                                title="Успешно обработано"
                                                                icon="check-square" 
                                                                scale="2" 
                                                                variant="success"
                                                            ></b-icon>
                                                        </template>
                                                        <template v-else-if="row['fight']">
                                                            <b-icon 
                                                                title="Необходимо решить конфликт свойств"
                                                                icon="info-circle-fill" 
                                                                scale="2" 
                                                                variant="info"
                                                            ></b-icon>
                                                        </template>
                                                        <template v-else-if="row['fault'] && row['fault']['error_type'] == 'no_prop_in_1c_dictionary'">
                                                            <b-icon 
                                                                :title="row['fault']['message']"
                                                                icon="exclamation-triangle-fill"
                                                                scale="2" 
                                                                variant="danger"
                                                            ></b-icon>
                                                        </template>
                                                        <template v-else-if="row['result'] == 'pass'">
                                                            <b-icon 
                                                                title="Строка пропущена"
                                                                icon="dash" 
                                                                scale="2" 
                                                                variant="secondary"
                                                            ></b-icon>
                                                        </template>                                                        
                                                        <template v-else>
                                                            <b-icon 
                                                                title="Неизвестно что делать"
                                                                icon="x-circle" 
                                                                scale="2" 
                                                                variant="danger"
                                                            ></b-icon>

                                                            <b-button 
                                                                v-if="typeof row[2] === 'number' || typeof row[3] === 'number' || typeof row[4] === 'number'"
                                                                variant="secondary" 
                                                                class="ml-2"
                                                                @click="solveProblem(row['fight'], row[0], item.name, r_index, row, true)"
                                                                style="width: 28px; padding: 0; height: 28px; margin-top: -3px;"
                                                            >
                                                                <b-icon 
                                                                    title="Заново обработать строку"
                                                                    icon="pencil-square" 
                                                                    variant="secondary"
                                                                ></b-icon>
                                                            </b-button>
                                                        </template>

                                                        <template v-if="(row['result'] == 'done') || (row['result'] == 'pass')">
                                                            <b-button 
                                                                v-if="typeof row[2] === 'number' || typeof row[3] === 'number' || typeof row[4] === 'number'"
                                                                variant="secondary" 
                                                                class="ml-2"
                                                                @click="solveProblem(row['fight'], row[0], item.name, r_index, row, true)"
                                                                style="width: 28px; padding: 0; height: 28px; margin-top: -3px;"
                                                            >
                                                                <b-icon 
                                                                    title="Заново обработать строку"
                                                                    icon="pencil-square" 
                                                                    variant="secondary"
                                                                ></b-icon>
                                                            </b-button>
                                                        </template>
                                                    </b-td>
                                                    <div 
                                                        class="fix-error" 
                                                        v-if="row['fight']"
                                                        @click="solveProblem(row['fight'], row[0], item.name, r_index, row)"
                                                    >Спорное свойство</div>
                                                    <div 
                                                        class="fix-error" 
                                                        v-if="row['fault'] && row['fault']['error_type'] == 'no_prop_in_1c_dictionary'"
                                                        @click="addPropTo1CDictionary(row['fault'], item.name, r_index)"
                                                    >Добавить свойство</div>
                                                </b-tr>
                                            </b-table-simple>                                          
                                        </b-collapse>
                                    </div>
                                </div>
                                </b-overlay>
                            </div>
                            <div v-if="addingFiles">
                                <tsoft-upload-area
                                    @changed="addFiles"
                                />                            
                            </div>
                        </div>
                        <div class="text-center my-5" v-if="files.has('files') && addingFiles">
                            <button 
                                class="btn btn-lg btn-primary" 
                                style="height: 50px;" 
                                @click="startLoadingFiles()"
                            >Обработать файлы</button>
                        </div>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>
        <BdrOneCSidebar
            :isOpen.sync='openAddPropTo1C'
            :editedItem.sync="editedAddPropTo1C"
            @updateItem="updateItem"
        ></BdrOneCSidebar> 
        <BdrSolveConflicts
            :isOpen.sync='openSolveConflicts'
            :conflict.sync="conflict"
            :solveWithoutPredictions="solveWithoutPredictions"
            @updateOtchet="updateOtchet"
        ></BdrSolveConflicts>       
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { API_BDR_IMPORT, API_BDR_SAVE_ONE_ELEMENT, API_BDR_FIND_FILES, API_BDR_RECALCULATE_FILES, API_BDR, API_BDR_HISTORY_IMPORT, API_BDR_1C_DICTIONARY, HOST_FOR_STORAGE } from '@/constants';
import BdrTableB2B from '@/components/bdrPage/BdrTableB2B.vue';
import BdrTableB2C from '@/components/bdrPage/BdrTableB2C.vue';
import BdrTableBSZ from '@/components/bdrPage/BdrTableBSZ.vue';
import BdrOneCSidebar from '@/components/bdrPage/BdrOneCSidebar';
import BdrSolveConflicts from '@/components/bdrPage/BdrSolveConflicts';
import stringSimilarity from 'string-similarity';

import { excelExportHelpers } from "@/mixins";

export default {
    components: { BdrTableB2B, BdrTableB2C, BdrTableBSZ, BdrOneCSidebar, BdrSolveConflicts },
    mixins: [ excelExportHelpers ],
    data() {
        return {
            loading: false,
            hfs: HOST_FOR_STORAGE,
            bdr: [],
            selected: {
                year: 2024,
                unit: {name: 'B2B', value: 'B2B'},
                month: 1
            },
            unitOptions: [
                {
                    text: 'Танаис B2C',
                    value: {name: 'B2C', value: 'B2C'}
                },
                {
                    text: 'Танаис B2B',
                    value: {name: 'B2B', value: 'B2B'}
                },
                {
                    text: 'БСЗ',
                    value: {name: 'БСЗ', value: 'BSZ'}
                },
            ], 
            months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
            addingFiles: true,
            recalculatingFiles: false,
            recalcOtchet: {},
            files: new FormData(),
            prevFiles: [],
            prevFilesLoading: false,
            openAddPropTo1C: false,
            editedAddPropTo1C: {},
            openSolveConflicts: false,
            conflict: {},
            dictionary: [],
            solveWithoutPredictions: false
        };
    },
    watch: {
        selected: {
            deep: true,
            handler(value) {
                this.recalcOtchet = {};
                this.findPrevFiles();
                this.recalculateFiles();
            },
        }, 
        prevFiles: {
            deep: true,
            handler(value) {
                if (value.length == 0) {
                    this.addingFiles = true;
                }
            },
        }, 
    },
    computed: {
        yearList() {
            const currentYear = new Date().getFullYear();
            const startYear = 2020;
            const yearsArray = [];

            for (let year = startYear; year <= currentYear; year++) {
                yearsArray.push({
                    text: year,
                    value: year
                });
            }            

            return yearsArray;
        },
        monthList() {
            const monthArray = [];

            this.months.forEach((month, index) => {
                monthArray.push({
                    text: month,
                    value: index + 1
                });
            });
            
            return monthArray;
        },
        currentTable() {
            return `BdrTable${this.selected.unit.value}`;
        }
    },
    mounted() {
        this.loadSelectedData();
        this.updateData();
        this.loadSelectedData();
    },
    methods: {
        ...mapActions('fileViewer', ['viewFile']),
        updateData() {
            this.getBDR();
            this.getDictionary();
            this.findPrevFiles();
            this.recalculateFiles();
        },

        getBDR() {
            this.loading = true;

            axios.get(`${API_BDR}?unit=${this.selected.unit.name}&year=${this.selected.year}`).then(({ data }) => {
                this.bdr = data;
                this.saveSelectedData();
                this.loading = false;
            });
        },

        getDictionary() {
            this.loading = true;
            axios.get(`${API_BDR_1C_DICTIONARY}?easylist=true`).then(({ data }) => {
                this.dictionary = data;
                this.loading = false;
            });
        },

        recalculateFiles(isReset = 0, isSilent = false, isAddingFiles = 0) {
            if (isReset && !isSilent) {
                let isExecuted = confirm("Вы уверены? Это сотрет историю загрузки и конфликты нужно будет решать заново.");
                if (!isExecuted) {
                    return false;
                }
            }
            this.recalculatingFiles = true;
            axios.get(`${API_BDR_RECALCULATE_FILES}?year=${this.selected.year}&month=${this.selected.month}&isReset=${isReset}&isAddingFiles=${isAddingFiles}`).then(({ data }) => {
                this.recalculatingFiles = false;
                this.recalcOtchet = data;
            }).catch(error => console.log(error));
        },

        findPrevFiles() {
            this.prevFilesLoading = true;
            axios.get(`${API_BDR_FIND_FILES}?year=${this.selected.year}&month=${this.selected.month}`).then(({ data }) => {
                this.prevFilesLoading = false;
                this.addingFiles = false;
                this.prevFiles = data;
            }).catch(error => console.log(error));
        },

        addFiles(files) {
            const formData = new FormData();
            formData.append('files', [])
            for (let i = 0; i < files.length; i++) {
                let file = files[i];
                formData.append('files[' + i + ']', file);
            }

            this.files = formData;
        },

        startLoadingFiles() {
            let isAddingFiles = 0;

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }       
            
            this.files.append('year', this.selected.year);
            this.files.append('month', this.selected.month);
            if (this.prevFiles.length > 0) {
                isAddingFiles = 1;
            }
            
            axios.post(`${API_BDR_IMPORT}`, this.files, config).then(({ data }) => {
                this.files = new FormData();
                this.addFiles(this.files);
                this.getBDR();
                this.findPrevFiles();
                this.recalculateFiles(0, false, isAddingFiles);             
            }).catch(error => console.log(error));
        },

        openFile(item) {
            if (this.fileExtension(item.path) !== 'txt') {
                this.viewFile({name: item.name, src: this.hfs + item.path})
            } else {
                window.open(this.hfs + item.path, '_blank');
            }
        },

        recalcOneFile(item) {
            let isExecuted = confirm("Точно делаем пересчет этого файла? Он будет заново обработать, но сотрутся все ручные операции.");
                if (!isExecuted) {
                    return false;
                }

            const request = {
                file_path: item.path,
                file_name: item.name,
                year: this.selected.year,
                month: this.selected.month,
                isAddingFiles: 1    // Эмулируем добавление нового файла.
            }
            
            axios.post(`${API_BDR}/recalc-one-file`, request).then(({ data }) => {
                this.findPrevFiles();
                this.recalculateFiles(0, false, 1);   
            }).catch(error => console.log(error));
        },

        deleteFile(item) {
            const request = {
                file_path: item.path,
                file_name: item.name,
                year: this.selected.year,
                month: this.selected.month
            }
            
            axios.post(`${API_BDR}/delete-one-file`, request).then(({ data }) => {
                this.findPrevFiles();
                this.recalculateFiles();             
            }).catch(error => console.log(error));
        },

        clearMonth() {
            let isExecuted = confirm("Вы уверены? Это удалит все файлы, цифры для всех компаний за выбранный месяц.");
                if (!isExecuted) {
                    return false;
                }

            const request = {
                year: this.selected.year,
                month: this.selected.month
            }
            
            axios.post(`${API_BDR}/clear-month`, request).then(({ data }) => {
                this.findPrevFiles();
                this.recalculateFiles(1, true);             
            }).catch(error => console.log(error));
        },

        addPropTo1CDictionary(fault, file_name, r_index) {
            this.openAddPropTo1C = true;
            this.editedAddPropTo1C = {
                fault: fault,
                name_from_file: fault['name_from_file'],
                file_name: file_name,
                r_index: r_index,                
                always_pass: 0,
                bdr_dictionary_id: '',
                unit_percent: '',
                property: {}
            };
        },

        updateItem(editedItem, property) {
            const bdr_elem = property.data;

            if (editedItem.file_name && editedItem.r_index) {
                this.loading = true;
                let priznak = this.getPriznakArrFromString(bdr_elem.unit_percent);

                const addBdrItem = {
                    "value" : editedItem.fault.value,
                    "bdr" : bdr_elem.property.external_number,
                    "onec_name" : bdr_elem.name_from_file,
                    "priznak" : priznak,
                    "1c_bdr" : bdr_elem.id,
                    "file_name" : editedItem.file_name,
                    "file_row" : editedItem.r_index,
                    "year" : editedItem.fault.year,
                    "month" : editedItem.fault.month,
                    "name" : bdr_elem.property.name,
                    "priznak_line" : bdr_elem.unit_percent,
                }

                axios.post(`${API_BDR_SAVE_ONE_ELEMENT}`, { 'addBdr': addBdrItem })
                .then(() => {
                    this.$toast.success("Значение успешно обновлено.", {
                        position: "top-right",
                        closeOnClick: true,
                        timeout: 6000,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 1,
                        showCloseButtonOnHover: true,
                        hideProgressBar: true,
                        closeButton: "button",
                        icon: "fa fa-exclamation-triangle",
                        rtl: false,
                    });
                }).finally(() => {
                    this.updateOtchet(editedItem.file_name, editedItem.r_index);
                    this.recalculateFiles();
                });

                // Добавлено из-за аномалий с обновление строк без свойства. Нужно капнуть глубже.
                setTimeout(() => {
                    this.updateOtchet(editedItem.file_name, editedItem.r_index);
                    this.recalculateFiles();
                }, 500);
            }
        },

        findNumberOrZero(obj) {
            for (let key in obj) {
                if (typeof obj[key] === 'number') {
                    return obj[key];
                }
            }

            return 0;
        },

        getPriznakArrFromString(unit_percent) {
            let priznakArr = unit_percent.split(',');
            let priznak = [];
            priznakArr.forEach((priznakElem) => {
                let priznakElemArr = priznakElem.split('%');
                priznak.push({"perc" : priznakElemArr[0],"unit" : priznakElemArr[1]});
            });

            return priznak;
        },

        solveProblem(row, name, file_name, r_index, fullRow, solveWithoutPredictions = false) {
            this.conflict = {
                list: row,
                name: name,
                file_name: file_name,
                r_index: r_index
            };

            this.solveWithoutPredictions = solveWithoutPredictions;

            if (this.solveWithoutPredictions) {
                let name = fullRow[0];
                let value = this.findNumberOrZero(fullRow);
                this.conflict.list = [];

                this.dictionary.forEach((bdr_elem) => {
                    if (bdr_elem.unit_percent) {
                        let similarityScore = stringSimilarity.compareTwoStrings(name.toLowerCase(), bdr_elem.name_from_file.toLowerCase());
                        let regex = new RegExp(name, 'i');

                        if (similarityScore > 0.6 || regex.test(bdr_elem.name_from_file)) {
                            let priznak = this.getPriznakArrFromString(bdr_elem.unit_percent);

                            this.conflict.list.push({
                                "value" : value,
                                "bdr" : bdr_elem.property.external_number,
                                "onec_name" : bdr_elem.name_from_file,
                                "priznak" : priznak,
                                "1c_bdr" : bdr_elem.id,
                                "file_name" : file_name,
                                "file_row" : r_index,
                                "year" : this.selected.year,
                                "month" : this.selected.month,
                                "name" : bdr_elem.property.name,
                                "priznak_line" : bdr_elem.unit_percent,
                                "checked" : false
                            });
                        }
                    }
                });
            }

            if (this.conflict.list.length == 0) {
                this.$toast.warning("Свойства для выбора отсутствуют. Добавьте свойства в Словарь и попробуйте снова.", {
                    position: "top-right",
                    closeOnClick: true,
                    timeout: 6000,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 1,
                    showCloseButtonOnHover: true,
                    hideProgressBar: true,
                    closeButton: "button",
                    icon: "fa fa-exclamation-triangle",
                    rtl: false,
                });
            } else {
                this.openSolveConflicts = true;
            }
        }, 
        
        updateOtchet(file_name, r_index) {
            this.recalcOtchet.otchet[file_name][r_index]['result'] = 'done';
            if (this.recalcOtchet.otchet[file_name][r_index]['fight']) {
                delete this.recalcOtchet.otchet[file_name][r_index]['fight'];
                delete this.recalcOtchet.fights[file_name][r_index];
            } else if (this.recalcOtchet.otchet[file_name][r_index]['fault']) {
                delete this.recalcOtchet.otchet[file_name][r_index]['fault'];
                delete this.recalcOtchet.faults[file_name][r_index];
            }

            this.loading = true;

            const inputData = {
                year: this.selected.year,
                month: this.selected.month,
                file_data: this.recalcOtchet
            }

            axios.post(`${API_BDR_HISTORY_IMPORT}`, inputData).then(({ data }) => {
                this.loading = false;
            });
        },

        numberOfFaults(file_name) {
            return this.recalcOtchet.faults[file_name] ? Object.keys(this.recalcOtchet.faults[file_name]).length : 0;
        },

        numberOfFights(file_name) {
            return this.recalcOtchet.fights[file_name] ? Object.keys(this.recalcOtchet.fights[file_name]).length : 0;
        },

        variantByResult(result) {
            switch (result) {
                case 'pass':
                    return 'light'
                    break;
            
                case 'error':
                    return 'danger'
                    break;
            
                case 'done':
                    return 'success'
                    break;
            
                default:
                    return 'light'
                    break;
            }
        },

        loadSelectedData() {
            if (localStorage.getItem('mySelectedData')) {
                this.selected = JSON.parse(localStorage.getItem('mySelectedData'));
            }
        },

        saveSelectedData() {
            localStorage.setItem('mySelectedData', JSON.stringify(this.selected));
        },
    },
}
</script>
<style scoped>
.bdr-results-head {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.bdr-results-head-selects {
    display: flex;
}

.bdr-tabs h5 {
    margin-bottom: 0;
}

.bdr-results-button {
    border: none;
    border-radius: 50%;
    background-color: transparent;
}

.table-otchet-of-import tr {
    position: relative;
}

.table-otchet-of-import tr div.fix-error {
    display: flex;
    z-index: -10;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #e37826cc;
    border: 1px solid #E37926;
    color: #FFF;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
    align-items: center;
    align-content: center;
    flex-wrap: nowrap;
    justify-content: center;
    cursor: pointer;
}
.table-otchet-of-import tr:hover div.fix-error {
    z-index: 10;
}
</style>